import { goRequest } from '../utils/httpClient';

export const getCountries = () =>
  goRequest({
    url: '/membership/countries',
    method: 'GET',
  });

export const getStates = (data) => {
  let url = '/membership/states';
  if (data.countryId) {
    url += `?country=${data.countryId}`;
  }
  return goRequest({
    url: url,
    method: 'GET',
  });
};

export const getPostalInfo = (data) => {
  let url = '/membership/postal_info';
  const searchParams = new URLSearchParams();
  if (data.countryId) {
    searchParams.append('country', data.countryId);
  }
  if (data.postalCode) {
    searchParams.append('postal_code', data.postalCode);
  }
  if (searchParams.toString()) {
    url += `?${searchParams.toString()}`;
  }
  return goRequest({
    url: url,
    method: 'GET',
  });
};
